import type {
  MergePeriodDto,
  DecisionChoice,
} from '../api/mergeResolution.types';

// Legal choices for a merge period, given its state.
export function legalChoices(period: MergePeriodDto): DecisionChoice[] {
  // A REOPENED cell the server flagged NoDecisionNeeded has no choices: every
  // route refuses a decision naming it. Row and range take, Custom and Clear
  // all check legality, so this one test covers them all.
  if (period.NoDecisionNeeded === true) {
    return [];
  }

  // An unchanged period asks no question, so there is nothing to Take or
  // Clear, but the user may still override Mine's value with a custom one.
  if (period.Class === 'UNCHANGED') {
    return period.Missing.length === 0 ? ['CUSTOM'] : [];
  }

  // Single-value-assumption rows (DateID === null) cannot be added on Mine side.
  if (period.DateID === null && period.Missing.includes('Mine')) {
    return [];
  }

  // Start from the full base order.
  let choices: DecisionChoice[] = ['MINE', 'THEIRS', 'CUSTOM', 'CLEAR'];

  // Remove illegal choices based on which sides are missing.
  if (period.Missing.includes('Mine')) {
    // Cannot choose Mine or Clear a conflict where Mine is missing.
    choices = choices.filter((c) => c !== 'MINE' && c !== 'CLEAR');
  }

  if (period.Missing.includes('Theirs')) {
    // Cannot choose Theirs where it is missing.
    choices = choices.filter((c) => c !== 'THEIRS');
  }

  return choices;
}

// Check if a specific choice is legal for a period.
export function isLegal(
  period: MergePeriodDto,
  choice: DecisionChoice
): boolean {
  return legalChoices(period).includes(choice);
}
